export const getPrefixedUrl = (url: string | undefined) => {
  if (!url) return "";
  return url?.charAt(0) === "/" ? url : `/${url}`;
};
